import { State } from './reducer';

const initialState: State = {
  basemapStyle: 'road',
  isSidePanelOpen: true,
  identify: {
    entities: [],
    selectedId: null,
  },
  internalMowing: {
    isVisible: true,
    isSettingsOpen: false,
    startDate: null,
    endDate: null,
    features: null,
  },
  publicMowing: {
    features: null,
  },
  sectionals: {
    isVisible: false,
  },
  tobinMaps: {
    isVisible: false,
  },
  abstracts: {
    isVisible: false,
  },
  beaumontZoning: {
    isVisible: false,
  },
  ditches: {
    isVisible: true,
    isSettingsOpen: false,
    categoryTypes: [
      {
        name: '001',
        isVisible: true,
      },
      {
        name: '100',
        isVisible: true,
      },
      {
        name: '200',
        isVisible: true,
      },
      {
        name: '300',
        isVisible: true,
      },
      {
        name: '400',
        isVisible: true,
      },
      {
        name: '500',
        isVisible: true,
      },
      {
        name: '600',
        isVisible: true,
      },
      {
        name: '700',
        isVisible: true,
      },
      {
        name: '800',
        isVisible: true,
      },
      {
        name: '900',
        isVisible: true,
      },
      {
        name: '1000',
        isVisible: true,
      },
      {
        name: '8000',
        isVisible: true,
      },
    ],
  },
  counties: {
    isVisible: false,
  },
  schoolDistricts: {
    isVisible: false,
  },
  subdivisions: {
    isVisible: false,
  },
  commissionerPrecincts: {
    isVisible: false,
  },
  drainageDistricts: {
    isVisible: false,
  },
  parcels: {
    isVisible: false,
  },
  subwatersheds: {
    isVisible: false,
  },
  watersheds: {
    isVisible: false,
  },
  ownership: {
    isVisible: false,
    isSettingsOpen: false,
    categoryTypes: [
      {
        name: 'Drainage Easement',
        isVisible: true,
      },
      {
        name: 'Encroachment',
        isVisible: true,
      },
      {
        name: 'Fee Property',
        isVisible: true,
      },
      {
        name: 'Map Record',
        isVisible: true,
      },
      {
        name: 'Map Record - DD6',
        isVisible: true,
      },
      {
        name: 'Release / Outsale',
        isVisible: true,
      },
      {
        name: 'Right-Of-Way',
        isVisible: true,
      },
      {
        name: 'Road / Access Easement',
        isVisible: true,
      },
      {
        name: 'Temporary Easement',
        isVisible: true,
      },
      {
        name: 'Other Easements',
        isVisible: true,
      },
      {
        name: 'Miscellaneous',
        isVisible: true,
      },
      {
        name: 'Visual Correction',
        isVisible: true,
      },
    ],
  },
  searchLocation: null,
};

export default initialState;
